import { Suspense, lazy } from 'react';

import { Color } from '../../lib/animation-colors/colors';
import { hexToRgb } from '../../lib/animation-colors/hex-to-rgb';
import { Solver } from '../../lib/animation-colors/solver';
import bitteAnimation from './../../assets/bitte_animation.json';

// Dynamically import Lottie to prevent Node 22 client errors
const Lottie = lazy(
  () => import('react-lottie-player/dist/LottiePlayerLight.js'),
);

export const BitteSpinner = ({
  width = 200,
  height = 200,
  color,
}: {
  width?: number;
  height?: number;
  color: string;
}) => {
  const rgb = hexToRgb(color) || [0, 0, 0];

  const colorObj = new Color(rgb[0], rgb[1], rgb[2]);
  const solver = new Solver(colorObj);
  const result = solver.solve();

  return (
    <Suspense fallback={<div style={{ width, height }} />}>
      <Lottie
        loop
        animationData={bitteAnimation}
        play
        speed={1.5}
        style={{ width, height, filter: result.filter }}
      />
    </Suspense>
  );
};
